module.exports = __webpack_public_path__ + "media/svg/failed-fa-189770a4.svg";